var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"id":"app-link"}},[_c('navbar',{attrs:{"title":"スポともダンスアプリ"}}),_c('background')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }